//libraries
import _ from 'lodash';

/**
 * Import all constants as an object.
 */
import * as actionType from "../../constants/actionType";


let initialState = {
  setting: []
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export default function (state, action) {
    state = state || initialState;
    switch (action.type) {
        case actionType.SALES_SUMMARY_CALCULATOR_SETTING:
            return _.assign({}, state, {
            setting: action.payload.setting
            });
        case actionType.SALES_SUMMARY_CALCULATOR_SETTING_RESET:
            return initialState;
        default:
            return state;
    }
}